"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import {PaveScaleCard} from "@/components/common/pave-scale-card";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

            <EspaceProTitleCard title={"Qui sommes-nous ?"}
                                middleBreadcrumbs={[{title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"}]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">
              <p className={"font-playfair-display italic font-bold text-center text-muted-foreground mb-8"}>
                  "Côte d'Ivoire Tourisme, un office reconnu pour son leadership et son audace dans la construction et le rayonnement de la Côte d'Ivoire comme destination touristique durable, responsable et équitable."
              </p>

              <div className={"text-normal"}>
                  Selon le décret n°2014-08 du 08 janvier 2014 précité, l’Établissement public à caractère commercial
                  COTE D’IVOIRE TOURISME a en charge la réalisation de 9 missions :

                  <ul className="list-disc list-inside text-lg mt-8">
                      <li className="li1">« […] Mettre en œuvre la politique du Gouvernement en matière de promotion
                          touristique ;
                      </li>
                      <li className="li1">Promouvoir et développer le potentiel touristique de la Côte d’Ivoire au
                          niveau national et international ;
                      </li>
                      <li className="li1">Assurer l’expansion de l’industrie touristique en faisant connaître et
                          apprécier par toutes actions et mesures de promotion nécessaires, les richesses touristiques
                          nationales,
                      </li>
                      <li className="li1">Organiser et coordonner la participation de la Côte d’Ivoire aux foires et
                          salons professionnels majeurs, tant au niveau national qu’au niveau international ;
                      </li>
                      <li className="li1">Stimuler les flux touristiques, voyages de groupes, incentives et congrès en
                          provenance des marchés émetteurs grâce à une présence active auprès des Tour-operators,
                      </li>
                      <li className="li1">Assurer l’information touristique et fournir la documentation aux
                          professionnels locaux et étrangers,
                      </li>
                      <li className="li1">Assister les artisans d’art dans les domaines de la production et de la
                          commercialisation de leurs produits,
                      </li>
                      <li className="li1">Apporter aux personnes physiques et morales, publiques ou privées, œuvrant
                          dans Ie secteur touristique, l’assistance technique nécessaire à la promotion de leurs
                          activités,
                      </li>
                      <li className="li1">Réaliser toutes études et entreprendre toutes actions commerciales,
                          industrielles, financières et immobilières susceptibles de contribuer, directement ou
                          indirectement, à la réalisation de son objet […]. »
                      </li>
                  </ul>
              </div>
          </SectionPage>

              <SectionPage sectionType="lg">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 mb-6">
                      <PaveScaleCard title={"Directeur Général et Ordonnateur"} buttonLabel={"Consulter"} className={"h-[400px]"}
                                     link="/espace-pro/office-de-tourisme/qui-sommes-nous/directeur-general-et-ordonnateur"
                                     image={"/images/espace-pro/office-du-tourisme/qui-sommes-nous/directeur-general-et-ordonnateur.jpg"}
                                     titleClassName={"font-playfair-display italic font-bold text-lg"}/>
                      <PaveScaleCard title={"Ressources Hummaines, Formation et Perfectionnement"} buttonLabel={"Consulter"} className={"h-[400px]"}
                                     link="/espace-pro/office-de-tourisme/qui-sommes-nous/ressources-humaines-formation-et-perfectionnement"
                                     image={"/images/espace-pro/office-du-tourisme/qui-sommes-nous/ressources-humaines-formation-et-perfectionnement.jpg"}
                                     titleClassName={"font-playfair-display italic font-bold text-lg"}/>
                      <PaveScaleCard title={"Budget, Finances et Moyens Généraux"} buttonLabel={"Consulter"}
                                     className={"h-[400px]"}
                                     link="/espace-pro/office-de-tourisme/qui-sommes-nous/budget-finances-et-moyens-generaux"
                                     image={"/images/espace-pro/office-du-tourisme/qui-sommes-nous/budget-finances-et-moyens-generaux.jpg"}
                                     titleClassName={"font-playfair-display italic font-bold text-lg"}/>
                      <PaveScaleCard title={"Statistiques et Suivi-Evaluation"} buttonLabel={"Consulter"} className={"h-[400px]"}
                                     link="/espace-pro/office-de-tourisme/qui-sommes-nous/statistiques-et-suivi-evaluation"
                                     image={"/images/espace-pro/office-du-tourisme/qui-sommes-nous/statistiques-et-suivi-evaluation.jpg"}
                                     titleClassName={"font-playfair-display italic font-bold text-lg"} />
                      <PaveScaleCard title={"Marketing, Communication, Technologies de l'Information et de la Communication"} buttonLabel={"Consulter"} className={"h-[400px]"}
                                     link="/espace-pro/office-de-tourisme/qui-sommes-nous/marketing-communication"
                                     image={"/images/espace-pro/office-du-tourisme/qui-sommes-nous/marketing-communication.jpg"}
                                     titleClassName={"font-playfair-display italic font-bold text-lg"} />
                      <PaveScaleCard title={"Relations Extérieures"} buttonLabel={"Consulter"} className={"h-[400px]"}
                                     link="/espace-pro/office-de-tourisme/qui-sommes-nous/relations-exterieures"
                                     image={"/images/espace-pro/office-du-tourisme/qui-sommes-nous/relations-exterieures.jpg"}
                                     titleClassName={"font-playfair-display italic font-bold text-lg"} />
            </div>
          </SectionPage>

        </div>
  );
}
